var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceimgone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.501,
    cy: 61.5432,
    r: 50.7998,
    stroke: "#1FC2C2",
    strokeOpacity: 0.19,
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5005,
    cy: 61.5432,
    r: 60.1333,
    stroke: "#1FC2C2",
    strokeOpacity: 0.19,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4803 50.8673C73.2723 50.8673 82.8316 47.2825 82.8316 42.8605C82.8316 38.4385 73.2723 34.8538 61.4803 34.8538C49.6882 34.8538 40.1289 38.4385 40.1289 42.8605C40.1289 47.2825 49.6882 50.8673 61.4803 50.8673Z",
    stroke: "#1FC2C2",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1396 58.4519C49.7452 58.9344 51.5408 59.3321 53.4775 59.626",
    stroke: "#1FC2C2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4803 69.5497C49.6882 69.5497 40.1289 65.9651 40.1289 61.543",
    stroke: "#1FC2C2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1396 77.1345C49.7452 77.6171 51.5408 78.0147 53.4775 78.3086",
    stroke: "#1FC2C2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4803 88.2325C49.6882 88.2325 40.1289 84.6479 40.1289 80.2257V42.8608M82.8316 42.8608V61.5433",
    stroke: "#1FC2C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.83 74.0157L79.6961 70.0481C78.028 67.9362 77.194 66.8804 76.1577 66.8804C75.1213 66.8804 74.2873 67.9362 72.6192 70.0481L69.4854 74.0157M76.1577 67.1131V88.2317",
    stroke: "#1FC2C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceimgone);
export default __webpack_public_path__ + "static/media/serviceimgone.daa8d75f297474c13c82311c31c27734.svg";
export { ForwardRef as ReactComponent };